/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import AppStack from '../../../../common/AppStack';
import WsSectionContainer from '../WsSectionContainer';
import AppText from '../../../../common/AppText';
import {
  getSelectedResources,
  getWebstoreHeadingSize
} from '../../../../../helpers/webstoreHelper';

const WsResourceBanner = ({
  blocks,
  config,
  themeConfig,
  colorSchemes,
  mediaQueries,
  pathname,
  ecomStoreTheme,
  resourceNavigation,
  ...rest
}) => {
  const colorScheme = colorSchemes[config.colorScheme - 1] ?? colorSchemes[0];
  const data = getSelectedResources(resourceNavigation, ecomStoreTheme);
  const { selected } = data;
  const isAllProducts = pathname.startsWith('/products');

  const title = isAllProducts ? 'All products' : selected?.name;
  const description =
    config.showResourceDescription === 'true'
      ? selected?.description
      : config.descriptionText;

  return (
    <WsSectionContainer
      colorScheme={colorScheme}
      config={config}
      mediaQueries={mediaQueries}
      themeConfig={themeConfig}
      withPadding
      {...rest}
    >
      <AppStack>
        {title && (
          <AppText
            style={{
              fontWeight: 600,
              fontSize: getWebstoreHeadingSize(config.headingSize)
            }}
          >
            {title}
          </AppText>
        )}

        {description && (
          <AppText style={{ fontSize: 16 }}>{description}</AppText>
        )}
      </AppStack>
    </WsSectionContainer>
  );
};

WsResourceBanner.propTypes = {
  blocks: PropTypes.array,
  colorSchemes: PropTypes.array,
  config: PropTypes.object,
  ecomStoreTheme: PropTypes.object,
  mediaQueries: PropTypes.object,
  pathname: PropTypes.string,
  resourceNavigation: PropTypes.array,
  themeConfig: PropTypes.object
};

export default WsResourceBanner;
